import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView } from '../../utils/metaPixel';

// Sirf wahi paths page-view count hone chahiye jo asli content page hain.
// App.js ka catch-all route (`path="*"` -> /404) har invalid URL ko /404 pe
// redirect karta hai. Bina is guard ke: base code PageView bhejta hai + redirect
// pe doosra PageView -> ek visit me 2 PageView, aur Meta ka data inflated ho jata hai.
const REAL_PAGE = [
  /^\/$/,
  /^\/shop$/,
  /^\/offers$/,
  /^\/category\/[^/]+$/,
  /^\/product\/[^/]+$/,
  /^\/cart$/,
  /^\/search$/,
  /^\/track$/,
  /^\/login$/,
  /^\/register$/,
  /^\/forgot-password$/,
  /^\/reset-password\/.+$/,
  /^\/checkout$/,
  /^\/order-confirmation\/[^/]+$/,
  /^\/my-orders$/,
  /^\/order\/[^/]+$/,
  /^\/wishlist$/,
  /^\/profile$/,
  /^\/admin$/,
  /^\/terms$/,
  /^\/privacy$/,
  /^\/shipping$/,
  /^\/faq$/,
];

const isRealPage = (path) => REAL_PAGE.some((re) => re.test(path));

// SPA me har route change pe fbq('track','PageView') bhejta hai.
// Pehla PageView index.html ke base code se already ja chuka hai,
// isliye pehla render skip karte hain warna PageView double count hoga.
const MetaPixelPageView = () => {
  const location = useLocation();
  const lastPath = useRef(null);
  const baseCovered = useRef(false);

  useEffect(() => {
    const path = location.pathname;
    if (lastPath.current === path) return;
    lastPath.current = path;

    if (!baseCovered.current) {
      baseCovered.current = true;
      return;
    }
    if (!isRealPage(path)) return;
    pageView();
  }, [location.pathname]);

  return null;
};

export default MetaPixelPageView;
